// External libraries
import { motion } from 'framer-motion';

// Utils
import { fadeIntoView } from '../../../../utils/animations';

export const pageNotFoundSVG = (
  <motion.svg
    {...fadeIntoView({ fadeDirection: 'bottom' })}
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1530_28525)">
      <g filter="url(#filter0_d_1530_28525)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.0001 0.0117477C37.7187 0.0117477 36.4484 0.279176 35.2673 0.791748L3.45441 15.634L3.37641 15.673C2.40154 16.1658 1.58245 16.9194 1.01021 17.8498C0.437968 18.7803 0.135005 19.8513 0.135005 20.9436C0.135005 22.036 0.437968 23.1069 1.01021 24.0374C1.58245 24.9678 2.40154 25.7214 3.37641 26.2142L3.45998 26.2587L35.2171 40.9673L35.2728 40.9952C36.4507 41.5074 37.7213 41.7717 39.0057 41.7717C40.2901 41.7717 41.5607 41.5074 42.7386 40.9952L74.557 26.1417L74.635 26.1027C75.6098 25.6099 76.4289 24.8564 77.0012 23.9259C77.5734 22.9955 77.8764 21.9245 77.8764 20.8322C77.8764 19.7398 77.5734 18.6689 77.0012 17.7384C76.4289 16.8079 75.6098 16.0544 74.635 15.5616L74.5514 15.517L42.7943 0.808462L42.7386 0.780605C41.5584 0.270276 40.2858 0.00855046 39.0001 0.0117477ZM77.6157 38.4212C78.0795 39.4275 78.1247 40.5768 77.7412 41.6164C77.3578 42.6559 76.5771 43.5007 75.571 43.9647L42.889 59.0188L42.8778 59.0243C41.6359 59.5903 40.287 59.8833 38.9221 59.8833C37.5573 59.8833 36.2083 59.5903 34.9664 59.0243L34.9386 59.0132L2.4237 43.9647C1.41743 43.4993 0.637274 42.6532 0.254861 41.6125C-0.127553 40.5718 -0.0809005 39.4219 0.384554 38.4156C0.850009 37.4093 1.69614 36.6292 2.73681 36.2468C3.77747 35.8644 4.92743 35.911 5.9337 36.3765L38.443 51.4249C38.5954 51.4935 38.7606 51.5289 38.9277 51.5289C39.0948 51.5289 39.26 51.4935 39.4124 51.4249L72.0777 36.3765C73.084 35.9126 74.2333 35.8675 75.2729 36.2509C76.3125 36.6344 77.1572 37.415 77.6213 38.4212H77.6157ZM75.571 62.0719C76.5594 61.5969 77.3215 60.7523 77.6928 59.7204C78.0641 58.6884 78.0149 57.5519 77.5557 56.556C77.0965 55.5601 76.2641 54.7846 75.2383 54.3969C74.2124 54.0092 73.0752 54.0403 72.0721 54.4836L39.4068 69.5265C39.2548 69.5959 39.0898 69.6323 38.9227 69.6333C38.7556 69.6342 38.5902 69.5997 38.4374 69.532L5.9337 54.4892C5.43292 54.2327 4.88552 54.0801 4.32431 54.0403C3.76311 54.0006 3.19966 54.0746 2.66774 54.2579C2.13583 54.4412 1.64641 54.73 1.22883 55.1071C0.811254 55.4841 0.474117 55.9416 0.237636 56.4521C0.00115501 56.9626 -0.129799 57.5156 -0.147375 58.0779C-0.16495 58.6403 -0.0687844 59.2004 0.135356 59.7246C0.339496 60.2489 0.647406 60.7266 1.04062 61.1289C1.43384 61.5313 1.90427 61.8502 2.4237 62.0663L34.9386 77.1203L34.9608 77.1315C36.2026 77.6982 37.5516 77.9915 38.9166 77.9915C40.2815 77.9915 41.6305 77.6982 42.8723 77.1315H42.889L75.571 62.0719Z"
          fill="url(#paint0_linear_1530_28525)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1530_28525"
        x="-6.26706"
        y="0.0117188"
        width="90.3837"
        height="90.2158"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6.11765" />
        <feGaussianBlur stdDeviation="3.05882" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1530_28525"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1530_28525"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1530_28525"
        x1="97.7529"
        y1="98.1154"
        x2="-23.4164"
        y2="94.2327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9D753A" />
        <stop offset="0.229167" stopColor="#F0915C" />
        <stop offset="0.588542" stopColor="#CB2950" />
        <stop offset="0.932255" stopColor="#F65C81" />
      </linearGradient>
      <clipPath id="clip0_1530_28525">
        <rect width="78" height="78" fill="white" />
      </clipPath>
    </defs>
  </motion.svg>
);
